// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : stats views and components
// =============================================================================
export const templates = true;
export const parts = true;
export const dashpanels = true;
import * as views from './views';
export { views };
export const selectors = {
    statistics: (root)=>root.data.stats?.[root.meta.request.dname]
};
